module.exports = __webpack_public_path__ + "static/media/personTester.ae86d0a8.png";